module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACAAQMAAAD58POIAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAATwAAAE8BY4r91wAAAAZQTFRFAAAAyvT8/YQw1wAAAAJ0Uk5TAP9bkSK1AAAAnklEQVR4nO3VPQ6DMAwFYCqGjD1CjpKjNb0ZUi9SJlakLgxRHiDiBAssfiao8rZ8kiNniF0Ul0oJfBkooGXwBDoGegXcQdjKUDAmFSHEpr6nUPeKoOVXpGYj0K2GwAd4iQAJIIPdCyeyeP6doIYz+MyggtN4Z8iQ4c+hHmH+93/wBs2ZgVJJ8BDBBliskzjY6UzLwUfQE6SVpHhfN0kP+OEUn0YUVoMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/atoms/Icon/icons/can-bin--cyan.png
// module id = 1713
// module chunks = 0